import { createFileRoute } from '@tanstack/react-router';
import '../css/Pricing.css';
import { PLANS } from '../constants/plans';

export const Route = createFileRoute('/pricing')({
  component: Pricing,
  validateSearch: (search: Record<string, unknown>): { plan?: string } => ({
    plan: typeof search.plan === 'string' ? search.plan : undefined,
  }),
});

function Pricing() {
  const { plan } = Route.useSearch();
  const preferredPlan = plan;

  return (
    <div className="pricing-container">
      <header className="pricing-header">
        <h1>Choose Your Plan</h1>
        <p>Unlock the full potential of TechNYC.io with a premium membership.</p>
      </header>

      <div className="pricing-grid">
        {PLANS.map((planItem) => {
          const isPreferred = preferredPlan === planItem.id;
          return (
            <article
              key={planItem.id}
              className={`pricing-card ${planItem.highlight ? 'featured' : ''}`}
              style={isPreferred ? { borderColor: '#fbbf24', boxShadow: '0 18px 45px rgba(251, 191, 36, 0.25)' } : undefined}
            >
              <div className="pricing-card-head">
                <h2>{planItem.name}</h2>
                <p>{planItem.description}</p>
              </div>
              <p className="price">{planItem.priceLabel}</p>
              <ul>
                {planItem.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              {planItem.cta.disabled ? (
                <button disabled>{planItem.cta.label}</button>
              ) : planItem.id === 'premium' ? (
                <a href="/checkout?plan=premium" className="cta-button">
                  {planItem.cta.label}
                </a>
              ) : (
                <a href={planItem.cta.href} className="cta-button">
                  {planItem.cta.label}
                </a>
              )}
            </article>
          )
        })}
      </div>
    </div>
  );
}

